query findEvent(
  $id: UUID!
) {
  event: eventByEventId(eventId: $id) {
    eventId
    eventName
    startsAt
    status
    matchState
    sportId
    competitors
    isUsaView
    eventType
    limbo
    source
    sport {
      sportId
      sportName
      sportLabel
    }
    region {
      regionId
      regionName
    }
    season {
      seasonId
      seasonName
    }
    competition {
      competitionId
      competitionName
      competitionFeedConfiguration: competitionFeedConfigurationsByCompetitionId {
        nodes {
          feed
          priority
          resultingMarketCategories
        }
      }
    }
    eventHasExternalPricesByEventId {
      nodes {
        hasExternalPrices
      }
    }
    eventHasInternalPricesByEventId {
      nodes {
        hasInternalPrices
      }
    }
    eventIsMappedsByEventId {
      nodes {
        isMapped
      }
    }
    booked: bookedEventsByEventId {
      nodes {
        bookedAt
        bookedBy
        pricingMode
      }
    }
    eventHighlightsByEventId {
      nodes {
        nodeId
      }
    }
    appliedTemplates: eventAppliedTemplatesByEventId {
      nodes {
        sportTemplate: appliedSportTemplate {
          sportTemplateId
          name
        }
      }
    }
    operatorEventSuspensionsByEventId {
      nodes {
        operatorId
      }
    }
    primaryFeedOverrides: eventPrimaryFeedOverridesByEventId {
      nodes {
        primaryFeeds
      }
    }
    soccerEventDetails: soccerAggregatesByEventId {
      nodes {
        actions
        attacksInMatch
        attacksPerPeriod
        available
        awayLineup
        awayScore
        awayScoreFirstLeg
        awayScorePenaltyShootout
        awayScoreRegularTime
        awayTeamId
        competitionType
        cornersInMatch
        cornersPerPeriod
        dangerousAttacksInMatch
        dangerousAttacksPerPeriod
        dangerousFreeKicksInMatch
        dangerousFreeKicksPerPeriod
        elapsedSecondInPeriod
        eventId
        eventInBreak
        eventPreMatch
        extraTimeHalfDuration
        firstYellowCardsInMatch
        firstYellowCardsPerPeriod
        foulsInMatch
        foulsPerPeriod
        freeKicksInMatch
        freeKicksPerPeriod
        goalKicksInMatch
        goalKicksPerPeriod
        halfDuration
        homeLineup
        homeScore
        homeScoreFirstLeg
        homeScorePenaltyShootout
        homeScoreRegularTime
        homeTeamId
        injuryTimeDuration
        injuryTimeDurationOfficial
        lastAction
        maxSubstitutions
        penaltiesInMatch
        penaltiesPerPeriod
        period
        redCardsInMatch
        redCardsPerPeriod
        riskFlags
        scorePerPeriod
        secondLeg
        shotsOffTargetInMatch
        shotsOffTargetPerPeriod
        shotsOnTargetInMatch
        shotsOnTargetPerPeriod
        source
        substitutionsInMatch
        substitutionsPerPeriod
        teamInPossession
        throwInsInMatch
        throwInsPerPeriod
        var
        varEnabled
        yellowCardsInMatch
        yellowCardsPerPeriod
        ownGoalsPerPeriod
        goalsFromPenaltyPerPeriod
        offsidesPerPeriod
        ownGoalsInMatch
        goalsFromPenaltyInMatch
        offsidesInMatch
        assistsInMatch
        accuratePassesInMatch
        totalPassesInMatch
        accurateCrossesInMatch
        totalCrossesInMatch
        tacklesInMatch
        interceptionsInMatch
        savesInMatch
      }
    }
    basketballEventDetails: basketballAggregatesByEventId {
      nodes {
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        foulThresholdForBonus
        foulsPerPeriod
        eventId
        ftsToCome
        nodeId
        onePointersPerPeriod
        otLengthInMinutes
        otPossible
        periodLengthInMinutes
        periods
        scorePerPeriod
        secondsLeftInPeriod
        teamInPossession
        threePointersPerPeriod
        twoPointersPerPeriod
        lastTeamToScore
        competitionType
        period
        clockRunning
        source
        homeLineup
        awayLineup
        fieldGoalPerPeriod
        fieldGoalPercentagePerPeriod
        fieldGoalPercentageInMatch
        twoPointAttemptsPerPeriod
        threePointAttemptsPerPeriod
        reboundsPerPeriod
        assistsPerPeriod
        possessionsCountPerPeriod
        eventInBreak
        eventPreMatch
        actions
        stealsPerPeriod        
        turnoversPerPeriod
        offensiveReboundsPerPeriod
        blocksPerPeriod
        available
      }
    }
    footballEventDetails: footballAggregatesByEventId {
      nodes {
        period
        gameTimeFromLastScoringEvent
        gameTimeElapsedInPeriod
        gameTimeRemainingInRegularGame
        inPossession
        downNumber
        yardsToWinDown
        lineOfScrimmageYard
        lineOfScrimmageTerritory
        downNumber
        yardsToEndZone
        yardsToWinDown
        isPlayRunning: playRunning
        isConversionEvent
        homeScore
        awayScore
        homeScoreFirstQuarter
        awayScoreFirstQuarter
        homeScoreSecondQuarter
        awayScoreSecondQuarter
        homeScoreThirdQuarter
        awayScoreThirdQuarter
        homeScoreFourthQuarter
        awayScoreFourthQuarter
        homeScoreOvertime
        awayScoreOvertime
        competitionName
        totalDownsNumber
        quarterDuration
        overtimeDuration
        overtimePossible
        homeTeamId
        homeLineup
        awayTeamId
        awayLineup
        source
        drives
        eventInBreak
        eventPreMatch
        awayTimeoutsLeft
        homeTimeoutsLeft
        available
      }
    }
    ultimateEventDetails: ultimateAggregatesByEventId {
      nodes {
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        eventId
        nodeId
        available
        clockRunning
        lastTeamToScore
        lastUpdated
        numberOfPeriods
        overTimeLengthMinutes
        period
        periodLengthMinutes
        pitchLengthMeters
        pitchWidthMeters
        scorePerPeriod
        secondsLeftInPeriod
        source
        teamInPossession
        eventInBreak
        eventPreMatch
      }
    }
    hockeyEventDetails: hockeyAggregatesByEventId {
      nodes {
        eventId
        lastTeamToScore
        period
        secondsLeftInPeriod
        scorePerPeriod
        foulsPerPeriod: penaltiesPerPeriod
        periods
        periodLengthInMinutes
        competitionType
        otPossible
        otLengthInMinutes
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        clockRunning
        timeOfLastClockStart
        lastUpdated
        source
        available
        teamInPossession
        eventInBreak
        eventPreMatch
        homeLineup
        awayLineup
        actions
        shotsOnGoal
        shotsOffTarget
        blockedShots
        goalsScoredOnEmptyNet
        powerPlayPercentage
        totalShotsOnGoal
        totalShotsOffTarget
        totalBlockedShots
        totalGoalsScoredOnEmptyNet
        totalPowerPlayPercentage
        powerPlayAdvantage
      }
    }
    baseballEventDetails: baseballAggregatesByEventId {
      nodes {
        eventId
        source
        lastUpdated
        matchRuns
        pitchCount
        loadedBases
        matchHits
        inningDetails
        currentTeamAPitcherProviderId
        currentTeamABatterProviderId
        currentTeamAPitcherId
        currentTeamABatterId
        currentTeamBPitcherProviderId
        currentTeamBBatterProviderId
        currentTeamBPitcherId
        currentTeamBBatterId
        teamABatterIds
        teamBBatterIds
        teamAPitcherIds
        teamBPitcherIds
        matchHomeRuns
        raceToMap
        available
        extraInningsSecondBaseRule
        regularInningsToBePlayed
        mercyRulePossible
        mercyRuleInningThreshold
        mercyRuleRunsAheadThreshold
        tiePossible
        tiePossibleInningThreshold
        homeTeamId
        awayTeamId
        eventInBreak
        eventPreMatch
        pitchCount
        loadedBases
        awayLineup
        homeLineup
        strikeOuts
      }
    }
    tennisEventDetails: tennisAggregatesByEventId {
      nodes {
        source
        lastUpdated
        homeTeamId
        awayTeamId
        available
        period
        matchTime
        setDurations
        currentServingTeam
        currentGameNumber
        currentGameScore
        pointsWonPerGame
        gamesWonInMatch
        gamesWonPerSet
        setsWon
        isPointInProgress
        secondServe
        eventPrematch
        eventPostmatch
        eventInBreak
        setsToPlay
        isDoubles
        isMen
        noAdvantage
        lastSetSuperTiebreak
        lastScoreUpdate
        riskFlags
        lastSetSuperTiebreakPoints
        acesInMatch
        acesPerSet
        doubleFaultsInMatch
        doubleFaultsPerSet
        breakPointsPlayedInMatch
        breakPointsWonInMatch
        breakPointsPlayedPerSet
        breakPointsWonPerSet
        breakPointsWonPercentageInMatch
        breakServePointsWonPercentagePerSet
        firstServePercentageInMatch
        firstServePercentagePerSet
        firstServePointsPlayedInMatch
        firstServePointsPlayedPerSet
        firstServePointsWonInMatch
        firstServePointsWonPerSet
        firstServePointsWonPercentageInMatch
        firstServePointsWonPercentagePerSet
        secondServePercentageInMatch
        secondServePercentagePerSet
        secondServePointsPlayedInMatch
        secondServePointsPlayedPerSet
        secondServePointsWonInMatch
        secondServePointsWonPerSet
        secondServePointsWonPercentageInMatch
        secondServePointsWonPercentagePerSet
      }
    }
    operatorEventUndisplaysByEventId {
      nodes {
        eventId
      }
    }
  }
}
